(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AeropuertoDetailController', AeropuertoDetailController);

    AeropuertoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Aeropuerto', 'Comercio', 'Provincia'];

    function AeropuertoDetailController($scope, $rootScope, $stateParams, previousState, entity, Aeropuerto, Comercio, Provincia) {
        var vm = this;

        vm.aeropuerto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:aeropuertoUpdate', function(event, result) {
            vm.aeropuerto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
